<template>
  <div v-if="fullDataStructure && fullDataStructure.Questions && categorizationsData">
    <div id="navigation-bar-container">
      <div v-if="currStep == 'questions-list'" id="navigation-bar-application">
        <div @click="pushURL('/rolesPage/SearchAppAdminApps/viewAppAdminApps')">
          <svg width="20" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.322 1.86938L9.73052 0.279377L1.06202 8.94488C0.922287 9.08373 0.811395 9.24884 0.735723 9.43072C0.660051 9.61259 0.621094 9.80764 0.621094 10.0046C0.621094 10.2016 0.660051 10.3967 0.735723 10.5785C0.811395 10.7604 0.922287 10.9255 1.06202 11.0644L9.73052 19.7344L11.3205 18.1444L3.18452 10.0069L11.322 1.86938Z" fill="black"/>
          </svg>
        </div>
        <h3>
          {{ fullDataStructure.title }}
        </h3>
        <button @click="saveAllData" class="primary-button-sm-global">Save</button>
      </div>
      <div v-else-if="currStep == 'question-edit'" id="navigation-bar-question">
        <div @click="currStep = 'questions-list'">
          <svg width="20" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.322 1.86938L9.73052 0.279377L1.06202 8.94488C0.922287 9.08373 0.811395 9.24884 0.735723 9.43072C0.660051 9.61259 0.621094 9.80764 0.621094 10.0046C0.621094 10.2016 0.660051 10.3967 0.735723 10.5785C0.811395 10.7604 0.922287 10.9255 1.06202 11.0644L9.73052 19.7344L11.3205 18.1444L3.18452 10.0069L11.322 1.86938Z" fill="black"/>
          </svg>
        </div>
        <h3>
          <input v-if="editQuestionTitle" style="font-size: 28px;" type="text" v-model="fullDataStructure.Questions[questionIndex].question" />
          <span v-else>{{ fullDataStructure.Questions[questionIndex].question }}</span>
          <svg v-if="!editQuestionTitle" @click="editQuestionTitle = true" style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 16.666H17.5" stroke="#7C7C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.75 2.9162C14.0815 2.58468 14.5312 2.39844 15 2.39844C15.2321 2.39844 15.462 2.44416 15.6765 2.533C15.891 2.62184 16.0858 2.75205 16.25 2.9162C16.4142 3.08036 16.5444 3.27523 16.6332 3.48971C16.722 3.70418 16.7678 3.93406 16.7678 4.1662C16.7678 4.39835 16.722 4.62822 16.6332 4.8427C16.5444 5.05717 16.4142 5.25205 16.25 5.4162L5.83333 15.8329L2.5 16.6662L3.33333 13.3329L13.75 2.9162Z" stroke="#7C7C7C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else @click="editQuestionTitle = false" style="cursor: pointer;" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        </h3>
        <button class="primary-button-sm-global">Preview Question</button>
      </div>
    </div>
    <div id="container" v-if="fullDataStructure.Questions != null && fullDataStructure != null">
      <dialog id="modal-settings">
        <svg @click="closeModal('modal-settings')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h3>
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.02057 17.3346C6.64557 17.3346 6.32279 17.2096 6.05224 16.9596C5.78168 16.7096 5.61835 16.4041 5.56224 16.043L5.37474 14.668C5.19418 14.5985 5.02418 14.5152 4.86474 14.418C4.7053 14.3207 4.54891 14.2166 4.39557 14.1055L3.10391 14.6471C2.75668 14.7999 2.40946 14.8138 2.06224 14.6888C1.71502 14.5638 1.44418 14.3416 1.24974 14.0221L0.270573 12.3138C0.0761284 11.9944 0.020573 11.6541 0.103906 11.293C0.18724 10.9319 0.37474 10.6332 0.666406 10.3971L1.77057 9.5638C1.75668 9.46658 1.74974 9.37269 1.74974 9.28214V8.71964C1.74974 8.62964 1.75668 8.53602 1.77057 8.4388L0.666406 7.60547C0.37474 7.36936 0.18724 7.07075 0.103906 6.70964C0.020573 6.34852 0.0761284 6.00825 0.270573 5.6888L1.24974 3.98047C1.44418 3.66102 1.71502 3.4388 2.06224 3.3138C2.40946 3.1888 2.75668 3.20269 3.10391 3.35547L4.39557 3.89714C4.54835 3.78602 4.70807 3.68186 4.87474 3.58464C5.04141 3.48741 5.20807 3.40408 5.37474 3.33464L5.56224 1.95964C5.61779 1.59852 5.78113 1.29297 6.05224 1.04297C6.32335 0.792969 6.64613 0.667969 7.02057 0.667969H8.97891C9.35391 0.667969 9.67696 0.792969 9.94807 1.04297C10.2192 1.29297 10.3822 1.59852 10.4372 1.95964L10.6247 3.33464C10.8053 3.40408 10.9756 3.48741 11.1356 3.58464C11.2956 3.68186 11.4517 3.78602 11.6039 3.89714L12.8956 3.35547C13.2428 3.20269 13.59 3.1888 13.9372 3.3138C14.2845 3.4388 14.5553 3.66102 14.7497 3.98047L15.7289 5.6888C15.9234 6.00825 15.9789 6.34852 15.8956 6.70964C15.8122 7.07075 15.6247 7.36936 15.3331 7.60547L14.2289 8.4388C14.2428 8.53602 14.2497 8.62991 14.2497 8.72047V9.28214C14.2497 9.37269 14.2359 9.46658 14.2081 9.5638L15.3122 10.3971C15.6039 10.6332 15.7914 10.9319 15.8747 11.293C15.9581 11.6541 15.9025 11.9944 15.7081 12.3138L14.7081 14.0221C14.5136 14.3416 14.2428 14.5638 13.8956 14.6888C13.5484 14.8138 13.2011 14.7999 12.8539 14.6471L11.6039 14.1055C11.4511 14.2166 11.2914 14.3207 11.1247 14.418C10.9581 14.5152 10.7914 14.5985 10.6247 14.668L10.4372 16.043C10.3817 16.4041 10.2186 16.7096 9.94807 16.9596C9.67752 17.2096 9.35446 17.3346 8.97891 17.3346H7.02057ZM7.16641 15.668H8.81224L9.10391 13.4596C9.53446 13.3485 9.93391 13.1855 10.3022 12.9705C10.6706 12.7555 11.0072 12.4949 11.3122 12.1888L13.3747 13.043L14.1872 11.6263L12.3956 10.2721C12.465 10.0777 12.5136 9.87297 12.5414 9.65797C12.5692 9.44297 12.5831 9.22408 12.5831 9.0013C12.5831 8.77852 12.5692 8.55991 12.5414 8.34547C12.5136 8.13102 12.465 7.92602 12.3956 7.73047L14.1872 6.3763L13.3747 4.95964L11.3122 5.83464C11.0067 5.51519 10.67 5.24797 10.3022 5.03297C9.93446 4.81797 9.53502 4.65464 9.10391 4.54297L8.83307 2.33464H7.18724L6.89557 4.54297C6.46502 4.65408 6.06585 4.81741 5.69807 5.03297C5.3303 5.24852 4.99335 5.5088 4.68724 5.8138L2.62474 4.95964L1.81224 6.3763L3.60391 7.70964C3.53446 7.91797 3.48585 8.1263 3.45807 8.33464C3.4303 8.54297 3.41641 8.76519 3.41641 9.0013C3.41641 9.22353 3.4303 9.4388 3.45807 9.64714C3.48585 9.85547 3.53446 10.0638 3.60391 10.2721L1.81224 11.6263L2.62474 13.043L4.68724 12.168C4.99279 12.4874 5.32974 12.7549 5.69807 12.9705C6.06641 13.186 6.46557 13.3491 6.89557 13.4596L7.16641 15.668ZM8.04141 11.918C8.84696 11.918 9.53446 11.6332 10.1039 11.0638C10.6733 10.4944 10.9581 9.80686 10.9581 9.0013C10.9581 8.19575 10.6733 7.50825 10.1039 6.9388C9.53446 6.36936 8.84696 6.08464 8.04141 6.08464C7.22196 6.08464 6.53113 6.36936 5.96891 6.9388C5.40668 7.50825 5.1253 8.19575 5.12474 9.0013C5.12418 9.80686 5.40557 10.4944 5.96891 11.0638C6.53224 11.6332 7.22307 11.918 8.04141 11.918Z" fill="#010101"/>
          </svg>
          Settings
        </h3>
        <nav>
          <span @click="settingsAppModalIndex = 0" :class="[settingsAppModalIndex == 0 ? 'selected-nav' : null]">Basic Info</span>
          <span @click="settingsAppModalIndex = 1" :class="[settingsAppModalIndex == 1 ? 'selected-nav' : null]">Pricing</span>
          <span @click="settingsAppModalIndex = 2" :class="[settingsAppModalIndex == 2 ? 'selected-nav' : null]">Additional Info</span>
        </nav>
        <hr />
        <div v-if="settingsAppModalIndex == 0">
          <label>Logo / Thumbnail</label>
          <div>
            <span style="margin-right: 5px;">
              <img v-if="typeof inputAppModal.image == 'string' && inputAppModal.image != ''" :src="`${reverseProxy}/api/${inputAppModal.image}`" alt="Picture N/A" loading="lazy" width="120px" height="80px" style="border-radius: 5px;" />
              <img v-else :src="getURLImage(inputAppModal.image)"  width="120px" height="80px" style="border-radius: 5px;" />
            </span>
            <label class="custom-file-label-global" style="display: inline-block;">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 16.0008C1.45 16.0008 0.979333 15.8051 0.588 15.4138C0.196666 15.0225 0.000666667 14.5515 0 14.0008V12.0008C0 11.7175 0.0960001 11.4801 0.288 11.2888C0.48 11.0975 0.717333 11.0015 1 11.0008C1.28267 11.0001 1.52033 11.0961 1.713 11.2888C1.90567 11.4815 2.00133 11.7188 2 12.0008V14.0008H14V12.0008C14 11.7175 14.096 11.4801 14.288 11.2888C14.48 11.0975 14.7173 11.0015 15 11.0008C15.2827 11.0001 15.5203 11.0961 15.713 11.2888C15.9057 11.4815 16.0013 11.7188 16 12.0008V14.0008C16 14.5508 15.8043 15.0218 15.413 15.4138C15.0217 15.8058 14.5507 16.0015 14 16.0008H2ZM7 3.8508L5.125 5.7258C4.925 5.9258 4.68767 6.0218 4.413 6.0138C4.13833 6.0058 3.90067 5.90146 3.7 5.7008C3.51667 5.5008 3.42067 5.26746 3.412 5.0008C3.40333 4.73413 3.49933 4.5008 3.7 4.3008L7.3 0.700796C7.4 0.600796 7.50833 0.53013 7.625 0.488796C7.74167 0.447463 7.86667 0.426463 8 0.425797C8.13333 0.42513 8.25833 0.44613 8.375 0.488796C8.49167 0.531463 8.6 0.60213 8.7 0.700796L12.3 4.3008C12.5 4.5008 12.596 4.73413 12.588 5.0008C12.58 5.26746 12.484 5.5008 12.3 5.7008C12.1 5.9008 11.8627 6.00513 11.588 6.0138C11.3133 6.02246 11.0757 5.92646 10.875 5.7258L9 3.8508V11.0008C9 11.2841 8.904 11.5218 8.712 11.7138C8.52 11.9058 8.28267 12.0015 8 12.0008C7.71733 12.0001 7.48 11.9041 7.288 11.7128C7.096 11.5215 7 11.2841 7 11.0008V3.8508Z" fill="black"/>
              </svg>
              Upload Image
              <input name="image" id="imported-logo" @change="(e) => {uploadAppImageToServer(e, inputAppModal, 'image');}" type="file" accept=".jpg, .jpeg, .png, .gif, .svg">
            </label>
          </div>
          <label>Classification / Application Type <span style="color: #FF0000;">*</span></label>
          <select name="classification" v-model="inputAppModal.classification">
            <option value="Assessment/Test">Assessment/Test</option>
            <option value="Questionnaire">Questionnaire</option>
          </select>
          <label>Title <span style="color: #FF0000;">*</span></label>
          <input name="area" type="text" v-model="inputAppModal.title">
          <label>Description</label>
          <textarea name="area" type="text" v-model="inputAppModal.info"></textarea>
          <div class="two-column">
            <label>Custom ID<span style="color: #FF0000;">*</span></label>
            <label>Area<span style="color: #FF0000;">*</span>:</label>
            <input name="info" type="text" placeholder="Unique code for your application" v-model="inputAppModal.application_custom_id">
            <input name="area" type="text" placeholder="Area of application" v-model="inputAppModal.area">
          </div>
        </div>
        <div v-else-if="settingsAppModalIndex == 1">
          <label>Will this application be on sale?<span style="color: #FF0000;">*</span></label>
          <select v-model="inputAppModal.on_sale">
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div>
            <label>Price per Unit</label>
            <select v-model="inputAppModal.currency_code" style="width: fit-content; display: inline-block; margin-right: .5rem;">
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="JPY">JPY</option>
              <option value="CNY">CNY</option>
              <option value="RUB">RUB</option>
            </select>
            <input type="text" style="width: 200px;" placeholder="Enter Amount" v-model="inputAppModal.single_unit_pricing" /> / Unit
          </div>
          <div>
            <label>Monthly Subscription Pricing</label>
            <select v-model="inputAppModal.currency_code" style="width: fit-content; display: inline-block; margin-right: .5rem;">
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="JPY">JPY</option>
              <option value="CNY">CNY</option>
              <option value="RUB">RUB</option>
            </select>
            <input type="text" style="width: 200px;" placeholder="Enter Amount" v-model="inputAppModal.monthly_subscription_pricing" /> / month
          </div>
        </div>
        <div v-else-if="settingsAppModalIndex == 2">
          <label>What is the age range for this application?</label>
            <input v-model="inputAppModal.ageRangeBegin" type="text" style="width: 60px;" placeholder="Age" /> 
              - 
            <input v-model="inputAppModal.ageRangeEnd" type="text" style="width: 60px;" placeholder="Age" /> Years
            <label>Estimated Duration of Application</label>
            <input v-model="inputAppModal.estimatedDurationHours" type="text" style="width: 60px;"/> hours
            <input v-model="inputAppModal.estimatedDurationMinutes" type="text" style="width: 60px;"/> minutes
        </div>
        <div style="display: flex; justify-content: flex-end; margin-top: 1rem;">
          <button @click="resetSettingAppModal(); closeModal('modal-settings')" style="margin-right: 10px;" class="secondary-gray-button-sm-global">Cancel</button>
          <button @click="updateApplicationMetaData" class="primary-button-sm-global">Update</button>
        </div>
      </dialog>
      <dialog id="modal-newQuestion">
        <svg @click="closeModal('modal-newQuestion')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <h3>New Questions</h3>
        <hr />
        <div class="two-column-box">
          <div class="side-nav-bar">
            <div :class="[newQuestionModalIndex == 0 ? 'active-index' : null]">
              <span class="circle">1</span>
              Categorization
            </div>
            <div :class="[newQuestionModalIndex == 1 ? 'active-index' : null]">
              <span class="circle">2</span>
              Question Basics
            </div>
            <div :class="[newQuestionModalIndex == 2 ? 'active-index' : null]">
              <span class="circle">3</span>
              Answers and Grading
            </div>
            <div :class="[newQuestionModalIndex == 3 ? 'active-index' : null]">
              <span class="circle">4</span>
              Additional Info
            </div>
          </div>
          <div>
            <div v-if="newQuestionModalIndex == 0">
              <div style="flex-grow: 1;">
                <h4>Categorization</h4>
                <p>Organize this question in to specific categories to manage grading and specific skills the question addresses.</p>
                <label>Type<span style="color: #FF0000;">*</span></label>
                <select v-model="inputNewQuestion.typeSelect">
                  <option value="" disabled selected>Select an option</option>
                  <option v-for="(type, index) in categorizationsData.types" :key="`typeQuestion-${index}`">{{ type }}</option>
                </select>
                <label>Category<span style="color: #FF0000;">*</span></label>
                <select v-model="inputNewQuestion.categorySelect">
                  <option value="" disabled selected>Select an option</option>
                  <option v-for="(categ, index) in categorizationsData.categories" :key="`categQuestion-${index}`">{{ categ }}</option>
                </select>
                <label>Subcategory<span style="color: #FF0000;">*</span></label>
                <select v-model="inputNewQuestion.sub_categorySelect">
                  <option value="" disabled selected>Select an option</option>
                  <option v-for="(subCateg, index) in categorizationsData.sub_categories" :key="`subCategQuestion-${index}`">{{ subCateg }}</option>
                </select>
              </div>
              <div style="display: flex; justify-content: flex-end;">
                <button class="primary-button-sm-global nav-buttons" @click="newQuestionModalIndex = 1">Next</button>
              </div>
            </div>
            <div v-else-if="newQuestionModalIndex == 1">
              <div style="flex-grow: 1;">
                <label><b>Question</b><span style="color: #FF0000;">*</span></label>
                <input type="text" v-model="inputNewQuestion.question" />
                <div style="display: flex; justify-content: space-between; margin-top: 5px;">
                  <b>Media</b>
                  <span class="brown-svg-text-button">
                    <label style="margin-top: 0;" for="newQuestion-media">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M14.1673 6.66667L10.0007 2.5L5.83398 6.66667"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 2.5V12.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Upload Media
                    </label>
                    <input @change="e => newQuestionMediaChanges(e)" style="display: none;" id="newQuestion-media" type="file" />
                  </span>
                </div>
                <div class="newQuestion-media-container">
                  <div v-for="(object,index) in inputNewQuestion.mediaList" class="accordion-container" :key="index">
                    <button class="accordion-button" @click="e => toggleAccordion(e)">
                            <img v-if="typeof object.image == 'string' && object.image != ''" :src="`${reverseProxy}/api/${object.image}`" alt="Picture N/A" loading="lazy" width="120px" height="80px" style="border-radius: 5px;" />
                            <img v-else :src="getURLImage(object.image)"  width="120px" height="80px" style="border-radius: 5px;" />
                    </button>
                    <div class="accordion-content">
                      <table>
                        <tbody>
                          <tr>
                            <td>Shape</td>
                            <td>
                              <select v-model="object.shape">
                                <option value="rectangle">Rectangle</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td>Styles</td>
                            <td style="display: grid; grid-template-columns: 1fr 1fr;">
                              <span>Fill:</span>
                              <input type="color" v-model="object.styles.backgroundColor" />
                              <span>Width:</span>
                              <input type="number" v-model="object.styles.width" />
                              <span>Height:</span>
                              <input type="number" v-model="object.styles.height" />
                              <span>X:</span>
                              <input type="number" v-model="object.styles.left" />
                              <span>Y:</span>
                              <input type="number" v-model="object.styles.top" />
                              <span>Z-Index</span>
                              <input type="number" v-model="object.styles.zIndex" />
                              <span>Font Size:</span>
                              <input type="number" v-model="object.styles.fontSize" />
                            </td>
                          </tr>
                          <tr>
                            <td>Content</td>
                            <td>
                              <input type="text" v-model="object.content" />
                            </td>
                          </tr>
                          <tr>
                            <td>Events</td>
                            <td style="display: grid; grid-template-columns: 1fr 1fr;">
                              <span>on_hover:</span>
                              <div></div>
                              <span>on_click:</span>
                              <div></div>
                              <span>on_double_click:</span>
                              <div></div>
                            </td>
                          </tr>
                          <tr>
                            <td>Answer Value</td>
                            <td>
                              <input type="text" v-model="object.answer_value" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: flex; justify-content: flex-end;">
                <button style="margin-right: 5px;" class="secondary-gray-button-sm-global nav-buttons" @click="newQuestionModalIndex = 0">Back</button>
                <button class="primary-button-sm-global nav-buttons" @click="newQuestionModalIndex = 2">Next</button>
              </div>
            </div>
            <div v-else-if="newQuestionModalIndex == 2" id="answer-grading-container">
              <div style="flex-grow: 1;">
                <h4>Answers and Grading</h4>
                <h6>Answer Type <span style="color: #FF0000;">*</span></h6>
                <div id="answer-type-container">
                  <span class="answer-type-box" @click="inputNewQuestion.answerType = 'mcq'" :class="[inputNewQuestion.answerType == 'mcq' ? 'selected-type' : null]">
                    <div>
                      <svg width="24" height="14" viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="24" height="5" rx="2.5" fill="#595959"/>
                        <rect y="9" width="24" height="5" rx="2.5" fill="#595959"/>
                      </svg>
                    </div>
                    <div>Multiple Choice / Push Button</div>
                  </span>
                  <span class="answer-type-box" @click="inputNewQuestion.answerType = 'verbal'" :class="[inputNewQuestion.answerType == 'verbal' ? 'selected-type' : null]">
                    <div>
                      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.834 5.83398L7.00065 10.5007H2.33398V17.5007H7.00065L12.834 22.1673V5.83398Z" stroke="#595959" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M22.2492 5.75195C24.4364 7.93978 25.665 10.9067 25.665 14.0003C25.665 17.0939 24.4364 20.0608 22.2492 22.2486M18.1309 9.87029C19.2244 10.9642 19.8388 12.4477 19.8388 13.9945C19.8388 15.5412 19.2244 17.0247 18.1309 18.1186" stroke="#595959" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </div>
                    <div>Verbal Response</div>
                  </span>
                </div>
<!--                 <h6>Grading System</h6>
                <div class="radio-system-container">
                  <div><input type="radio" v-model="inputNewQuestion.radioBinaryOrScaled" name="grading-system" value="binary" /></div>
                  <div>
                    <b>Binary</b>
                    <div class="subText">
                      Answer is either correct (+1) or incorrect (+0)
                    </div>
                  </div>
                </div>
                <div class="radio-system-container">
                  <div><input type="radio" v-model="inputNewQuestion.radioBinaryOrScaled" name="grading-system" value="scaled" /></div>
                  <div>
                    <b>Scaled</b>
                    <div class="subText">
                      Answer has a scale of correctedness 
                    </div>
                  </div>
                </div> -->
                <h6 style="margin-top: 1rem;">Correct Answers</h6>
                <div v-for="(_, index) in inputNewQuestion.correctAnswers" :key="`correctAnswer-${index}`" style="display: grid; grid-template-columns: auto 1fr;">
                  <svg @click="removeNewCorrectAnswer(index)" style="cursor: pointer;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 6H5H21" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <input v-model="inputNewQuestion.correctAnswers[index]" placeholder="[Insert Answer]" type="text" />
                </div>
                <span @click="addNewCorrectAnswer(inputNewQuestion.correctAnswers)" class="orangeText-600" style="cursor: pointer;">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M0.833984 10.0007C0.833984 4.9379 4.9379 0.833984 10.0007 0.833984C15.0634 0.833984 19.1673 4.9379 19.1673 10.0007C19.1673 15.0634 15.0634 19.1673 10.0007 19.1673C4.9379 19.1673 0.833984 15.0634 0.833984 10.0007ZM10.0007 2.66732C8.05573 2.66732 6.19047 3.43993 4.8152 4.8152C3.43993 6.19047 2.66732 8.05573 2.66732 10.0007C2.66732 11.9456 3.43993 13.8108 4.8152 15.1861C6.19047 16.5614 8.05573 17.334 10.0007 17.334C11.9456 17.334 13.8108 16.5614 15.1861 15.1861C16.5614 13.8108 17.334 11.9456 17.334 10.0007C17.334 8.05573 16.5614 6.19047 15.1861 4.8152C13.8108 3.43993 11.9456 2.66732 10.0007 2.66732Z" fill="#B46909"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9167 5.41667C10.9167 5.17355 10.8201 4.94039 10.6482 4.76849C10.4763 4.59658 10.2431 4.5 10 4.5C9.75689 4.5 9.52373 4.59658 9.35182 4.76849C9.17991 4.94039 9.08333 5.17355 9.08333 5.41667V9.08333H5.41667C5.17355 9.08333 4.94039 9.17991 4.76849 9.35182C4.59658 9.52373 4.5 9.75689 4.5 10C4.5 10.2431 4.59658 10.4763 4.76849 10.6482C4.94039 10.8201 5.17355 10.9167 5.41667 10.9167H9.08333V14.5833C9.08333 14.8264 9.17991 15.0596 9.35182 15.2315C9.52373 15.4034 9.75689 15.5 10 15.5C10.2431 15.5 10.4763 15.4034 10.6482 15.2315C10.8201 15.0596 10.9167 14.8264 10.9167 14.5833V10.9167H14.5833C14.8264 10.9167 15.0596 10.8201 15.2315 10.6482C15.4034 10.4763 15.5 10.2431 15.5 10C15.5 9.75689 15.4034 9.52373 15.2315 9.35182C15.0596 9.17991 14.8264 9.08333 14.5833 9.08333H10.9167V5.41667Z" fill="#B46909"/>
                  </svg>
                  Add Answer
                </span>
              </div>
              <div style="display: flex; justify-content: flex-end;">
                <button style="margin-right: 5px;" class="secondary-gray-button-sm-global nav-buttons" @click="newQuestionModalIndex = 1">Back</button>
                <button class="primary-button-sm-global nav-buttons" @click="newQuestionModalIndex = 3">Next</button>
              </div>
            </div>
            <div v-else-if="newQuestionModalIndex == 3">
              <div style="flex-grow: 1;">
                <label>What is the intended age range for this question?</label>
                <input v-model="inputNewQuestion.ageRangeNewBegin" placeholder="Age" type="text" style="width: 60px;"/>
                -
                <input v-model="inputNewQuestion.ageRangeNewEnd" placeholder="Age" type="text" style="width: 60px;"/>
                Years
                <label>What is the typical time it takes to complete this question?</label>
                <input v-model="inputNewQuestion.typicalDurationNewBegin" type="text" style="width: 60px;"/> hours
                <input v-model="inputNewQuestion.typicalDurationNewEnd" type="text" style="width: 60px;"/> minutes
                <label>What is the upper time limit of this activity?</label>
                <input v-model="inputNewQuestion.timeOutNewBegin" type="text" style="width: 60px;"/> hours
                <input v-model="inputNewQuestion.timeOutNewEnd" type="text" style="width: 60px;"/> minutes
              </div>
              <div style="display: flex; justify-content: flex-end;">
                <button style="margin-right: 5px;" class="secondary-gray-button-sm-global nav-buttons" @click="newQuestionModalIndex = 2">Back</button>
                <button class="primary-button-sm-global nav-buttons" @click="addNewQuestion(); closeModal('modal-newQuestion')">Create Question</button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
      <dialog id="modal-Categorizations">
        <svg @click="closeModal('modal-Categorizations')" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <div v-if="showNestingTree" @click="showNestingTree = false" class="back-button">Back</div>
        <h4>Type, Categories, Subcategories</h4>
        <hr />
        <div v-if="!showNestingTree">
          <label>Types</label>
          <small>Type is the largest category. For example, gross motor skills is a type.</small>
          <div class="internalGrid">
            <input type="text" placeholder="Enter type word" v-model="inputModalCategorizations.typeAdd" />
            <button @click="addingNestedCategorizations('type')" class="primary-button-sm-global">Add</button>
          </div>
          <label>Categories</label>
          <small>Category is the 2nd level of organization. For example, stationary movements > gross motor skills.</small>
          <div class="internalGrid">
            <div class="internalGrid2">
              <select v-model="inputModalCategorizations.selectType">
                <option value="" disabled selected>Select a parent type</option>
                <option v-for="(typeValue, typeIndex) in categorizationsData.types" :key="`typeAdd-${typeIndex}`">
                  {{ typeValue }}
                </option>
              </select>
              <input v-model="inputModalCategorizations.categoriesAdd" placeholder="Enter category word" type="text" />
            </div>
            <button @click="addingNestedCategorizations('category')" class="primary-button-sm-global">Add</button>
          </div>
          <label>Subcategories</label>
          <small>Category is the 3rd level of organizations. For example, sitting > stationary movements > gross motor.</small>
          <div class="internalGrid">
            <div style="margin-bottom: 5px;" class="internalGrid2">
              <select v-model="inputModalCategorizations.selectSubCategType">
                <option value="" disabled selected>Select a parent type</option>
                <option v-for="(typeValue, typeIndex) in categorizationsData.types" :key="`typeAdd-${typeIndex}`">
                  {{ typeValue }}
                </option>
              </select>
              <select v-model="inputModalCategorizations.selectSubCategCategory">
                <option value="" disabled selected>Select a parent type</option>
                <option v-for="(categValue, categIndex) in categorizationsData.categories" :key="`categAdd-${categIndex}`">
                  {{ categValue }}
                </option>
              </select>
            </div>
            <div></div>
          </div>
          <div class="internalGrid">
            <input v-model="inputModalCategorizations.subCategoryAdd" type="text" placeholder="Enter subcategory word" />
            <button @click="addingNestedCategorizations('subCateg')" class="primary-button-sm-global">Add</button>
          </div>
        </div>
        <div v-else>
          <ul class="tree-list-global">
            <li v-for="(typeValue, typeKey, typeIndex) in nestedCategorizations" :key="`type-${typeIndex}`">
              <details open>
                <summary>{{ typeKey }}</summary>
                <ul>
                  <li v-for="(categoryValue, categoryKey, categoryIndex) in typeValue" :key="`category-${categoryIndex}`">
                    <details open>
                      <summary>{{ categoryKey }}</summary>
                      <ul>
                        <li v-for="(subCategoryValue, subCategoryKey, subCategoryIndex) in categoryValue" :key="`category-${subCategoryIndex}`">
                          {{ subCategoryKey }}
                        </li>
                      </ul>
                    </details>
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </div>
        <button v-if="!showNestingTree" @click="showNestingTree = true" style="margin-top: 1rem;" class="primary-button-sm-global">View Your Type, Categories, and Subcategories</button>
      </dialog>
      <div v-if="currStep == 'questions-list' || currStep == 'question-edit'" id="main-box-container">
        <div v-if="currStep == 'questions-list'" class="main-box-grid">
          <section>
            <div>
              <div class="question-grid">
                <div></div>
                <h3>Questions</h3>
              </div>
              <div v-for="(item,index) in fullDataStructure.Questions" :key="index" class="question-grid">
                <div>{{ index+1 }}</div>
                <button style="text-align: left;" class="secondary-gray-button-sm-global" @click="changeIndex('question', index); currStep = 'question-edit'; formatForNewResolution('preview-screen-specialist')">{{ item.question }}</button>
              </div>
              <div class="question-grid">
                <div></div>
                <button class="secondary-gray-button-sm-global" @click="openModal('modal-newQuestion')">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 8H1C0.71667 8 0.479337 7.904 0.288004 7.712C0.0966702 7.52 0.000670115 7.28267 3.44827e-06 7C-0.000663218 6.71734 0.0953369 6.48 0.288004 6.288C0.48067 6.096 0.718003 6 1 6H6V1C6 0.71667 6.096 0.479337 6.288 0.288004C6.48 0.0966702 6.71734 0.000670115 7 3.44827e-06C7.28267 -0.000663218 7.52034 0.0953369 7.713 0.288004C7.90567 0.48067 8.00134 0.718003 8 1V6H13C13.2833 6 13.521 6.096 13.713 6.288C13.905 6.48 14.0007 6.71734 14 7C13.9993 7.28267 13.9033 7.52034 13.712 7.713C13.5207 7.90567 13.2833 8.00134 13 8H8V13C8 13.2833 7.904 13.521 7.712 13.713C7.52 13.905 7.28267 14.0007 7 14C6.71734 13.9993 6.48 13.9033 6.288 13.712C6.096 13.5207 6 13.2833 6 13V8Z" fill="black"/>
                  </svg>
                  New Question
                </button>
              </div>
            </div>
          </section>
          <section class="application-sidebar">
            <div>
              <button style="width: 100%" @click="openModal('modal-Categorizations')">Type, Categories, Subcategories</button>
<!--               <button style="width: 100%; margin-top: 10px;">
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.625 1.625H3.375C2.4085 1.625 1.625 2.4085 1.625 3.375V15.625C1.625 16.5915 2.4085 17.375 3.375 17.375H15.625C16.5915 17.375 17.375 16.5915 17.375 15.625V3.375C17.375 2.4085 16.5915 1.625 15.625 1.625Z" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M1.625 6.875H17.375M1.625 12.125H17.375M6.875 6.875V17.375M12.125 6.875V17.375" stroke="#9D9D9D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Upload Spreadsheet
              </button> -->
              <button style="width: 100%; margin-top: 10px;" @click="openModal('modal-settings')">
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.02057 17.3346C6.64557 17.3346 6.32279 17.2096 6.05224 16.9596C5.78168 16.7096 5.61835 16.4041 5.56224 16.043L5.37474 14.668C5.19418 14.5985 5.02418 14.5152 4.86474 14.418C4.7053 14.3207 4.54891 14.2166 4.39557 14.1055L3.10391 14.6471C2.75668 14.7999 2.40946 14.8138 2.06224 14.6888C1.71502 14.5638 1.44418 14.3416 1.24974 14.0221L0.270573 12.3138C0.0761284 11.9944 0.020573 11.6541 0.103906 11.293C0.18724 10.9319 0.37474 10.6332 0.666406 10.3971L1.77057 9.5638C1.75668 9.46658 1.74974 9.37269 1.74974 9.28214V8.71964C1.74974 8.62964 1.75668 8.53602 1.77057 8.4388L0.666406 7.60547C0.37474 7.36936 0.18724 7.07075 0.103906 6.70964C0.020573 6.34852 0.0761284 6.00825 0.270573 5.6888L1.24974 3.98047C1.44418 3.66102 1.71502 3.4388 2.06224 3.3138C2.40946 3.1888 2.75668 3.20269 3.10391 3.35547L4.39557 3.89714C4.54835 3.78602 4.70807 3.68186 4.87474 3.58464C5.04141 3.48741 5.20807 3.40408 5.37474 3.33464L5.56224 1.95964C5.61779 1.59852 5.78113 1.29297 6.05224 1.04297C6.32335 0.792969 6.64613 0.667969 7.02057 0.667969H8.97891C9.35391 0.667969 9.67696 0.792969 9.94807 1.04297C10.2192 1.29297 10.3822 1.59852 10.4372 1.95964L10.6247 3.33464C10.8053 3.40408 10.9756 3.48741 11.1356 3.58464C11.2956 3.68186 11.4517 3.78602 11.6039 3.89714L12.8956 3.35547C13.2428 3.20269 13.59 3.1888 13.9372 3.3138C14.2845 3.4388 14.5553 3.66102 14.7497 3.98047L15.7289 5.6888C15.9234 6.00825 15.9789 6.34852 15.8956 6.70964C15.8122 7.07075 15.6247 7.36936 15.3331 7.60547L14.2289 8.4388C14.2428 8.53602 14.2497 8.62991 14.2497 8.72047V9.28214C14.2497 9.37269 14.2359 9.46658 14.2081 9.5638L15.3122 10.3971C15.6039 10.6332 15.7914 10.9319 15.8747 11.293C15.9581 11.6541 15.9025 11.9944 15.7081 12.3138L14.7081 14.0221C14.5136 14.3416 14.2428 14.5638 13.8956 14.6888C13.5484 14.8138 13.2011 14.7999 12.8539 14.6471L11.6039 14.1055C11.4511 14.2166 11.2914 14.3207 11.1247 14.418C10.9581 14.5152 10.7914 14.5985 10.6247 14.668L10.4372 16.043C10.3817 16.4041 10.2186 16.7096 9.94807 16.9596C9.67752 17.2096 9.35446 17.3346 8.97891 17.3346H7.02057ZM7.16641 15.668H8.81224L9.10391 13.4596C9.53446 13.3485 9.93391 13.1855 10.3022 12.9705C10.6706 12.7555 11.0072 12.4949 11.3122 12.1888L13.3747 13.043L14.1872 11.6263L12.3956 10.2721C12.465 10.0777 12.5136 9.87297 12.5414 9.65797C12.5692 9.44297 12.5831 9.22408 12.5831 9.0013C12.5831 8.77852 12.5692 8.55991 12.5414 8.34547C12.5136 8.13102 12.465 7.92602 12.3956 7.73047L14.1872 6.3763L13.3747 4.95964L11.3122 5.83464C11.0067 5.51519 10.67 5.24797 10.3022 5.03297C9.93446 4.81797 9.53502 4.65464 9.10391 4.54297L8.83307 2.33464H7.18724L6.89557 4.54297C6.46502 4.65408 6.06585 4.81741 5.69807 5.03297C5.3303 5.24852 4.99335 5.5088 4.68724 5.8138L2.62474 4.95964L1.81224 6.3763L3.60391 7.70964C3.53446 7.91797 3.48585 8.1263 3.45807 8.33464C3.4303 8.54297 3.41641 8.76519 3.41641 9.0013C3.41641 9.22353 3.4303 9.4388 3.45807 9.64714C3.48585 9.85547 3.53446 10.0638 3.60391 10.2721L1.81224 11.6263L2.62474 13.043L4.68724 12.168C4.99279 12.4874 5.32974 12.7549 5.69807 12.9705C6.06641 13.186 6.46557 13.3491 6.89557 13.4596L7.16641 15.668ZM8.04141 11.918C8.84696 11.918 9.53446 11.6332 10.1039 11.0638C10.6733 10.4944 10.9581 9.80686 10.9581 9.0013C10.9581 8.19575 10.6733 7.50825 10.1039 6.9388C9.53446 6.36936 8.84696 6.08464 8.04141 6.08464C7.22196 6.08464 6.53113 6.36936 5.96891 6.9388C5.40668 7.50825 5.1253 8.19575 5.12474 9.0013C5.12418 9.80686 5.40557 10.4944 5.96891 11.0638C6.53224 11.6332 7.22307 11.918 8.04141 11.918Z" fill="#949494"/>
                </svg>
                Application Settings
              </button>
            </div>
            <div style="display: flex; column-gap: 10px; justify-content: center; flex-wrap: wrap;">
              <button class="secondary-color-button-sm-global">
                Preview
              </button>
              <div>
                <div v-if="!loadingPublishApps">
                  <button v-if="fullDataStructure.published" class="primary-button-sm-global" @click="publishApp(false)">
                    Unpublish
                  </button>
                  <button v-else class="primary-button-sm-global" @click="publishApp(true)">
                    Publish
                  </button>
                </div>
                <div v-else>
                  <button v-if="fullDataStructure.published" class="primary-button-sm-global">
                    <b-spinner small></b-spinner>
                    Unpublish
                  </button>
                  <button v-else class="primary-button-sm-global">
                    <b-spinner small></b-spinner>
                    Publish
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div v-else-if="currStep == 'question-edit'" class="main-box-grid">
          <section v-if="fullDataStructure.classification == 'Assessment/Test'">
            <div style="display: flex; justify-content: space-between;">
              <b>Child View</b>
              <span class="brown-svg-text-button">
                <label style="margin-top: 0;" for="question-media-add-more">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.1673 6.66667L10.0007 2.5L5.83398 6.66667"  stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 2.5V12.5" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Upload More Media
                </label>
                <input @change="e => addMediaEditQuestion(e)" style="display: none;" id="question-media-add-more" type="file" />
              </span>
            </div>
            <div id="preview-screen-specialist" :style="{backgroundColor:fullDataStructure.Questions[questionIndex].background_color, position: 'relative', height: '500px'}" style="border: solid #8E8E8E 1px;">
              <DragResizeElement
                v-for="(element, index2) in fullDataStructure.Questions[questionIndex].Elements" :key="`element-${index2}`"
                :style="{
                  top: `${element.styles.top}px`,
                  left: ` ${element.styles.left}px`,
                  width: `${element.styles.width}px`,
                  height: `${element.styles.height}px`,
                  backgroundColor: element.styles.backgroundColor,
                  zIndex: element.styles.zIndex,
                  fontSize: `${element.styles.fontSize}px`,
                }"
                class="resizable-button-container"
                @deselectObjectMoveResize="deselectObjectMoveResize"
                @selectObjectMoveResize="selectObjectMoveResize"
                @emitNewChangeOccured="emitNewChangeOccured"
                :detailsObject="element"
                :bound="true"
              >
                <img v-if="element.image != ''" :src="`${reverseProxy}/api/${element.image}`" width="100%" height="100%">
                <div class="placeholder-rect" @click="editElementData = element">{{ element.content }}</div>
              </DragResizeElement>
            </div>
            <div>
              <h5>Edit Question Configuration</h5>
              <p>Define which interactions count as correct for this question</p>
              <table>
                <tbody>
                  <tr>
                    <td>Correct Answers:</td>
                    <td style="width: 100%; padding-left: 1rem;">
                      <div v-for="(_, index) in fullDataStructure.Questions[questionIndex].correct_answers" :key="`correctAnswer-${index}`" style="display: grid; grid-template-columns: auto 1fr;">
                        <svg @click="removeCurrentCorrectAnswer(index)" style="cursor: pointer;" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#B9B9B9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <input v-model="fullDataStructure.Questions[questionIndex].correct_answers[index]" placeholder="[Insert Answer]" type="text" />
                      </div>
                      <span @click="addCurrentCorrectAnswer(fullDataStructure.Questions[questionIndex].correct_answers)" class="orangeText-600" style="cursor: pointer;">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.833984 10.0007C0.833984 4.9379 4.9379 0.833984 10.0007 0.833984C15.0634 0.833984 19.1673 4.9379 19.1673 10.0007C19.1673 15.0634 15.0634 19.1673 10.0007 19.1673C4.9379 19.1673 0.833984 15.0634 0.833984 10.0007ZM10.0007 2.66732C8.05573 2.66732 6.19047 3.43993 4.8152 4.8152C3.43993 6.19047 2.66732 8.05573 2.66732 10.0007C2.66732 11.9456 3.43993 13.8108 4.8152 15.1861C6.19047 16.5614 8.05573 17.334 10.0007 17.334C11.9456 17.334 13.8108 16.5614 15.1861 15.1861C16.5614 13.8108 17.334 11.9456 17.334 10.0007C17.334 8.05573 16.5614 6.19047 15.1861 4.8152C13.8108 3.43993 11.9456 2.66732 10.0007 2.66732Z" fill="#B46909"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9167 5.41667C10.9167 5.17355 10.8201 4.94039 10.6482 4.76849C10.4763 4.59658 10.2431 4.5 10 4.5C9.75689 4.5 9.52373 4.59658 9.35182 4.76849C9.17991 4.94039 9.08333 5.17355 9.08333 5.41667V9.08333H5.41667C5.17355 9.08333 4.94039 9.17991 4.76849 9.35182C4.59658 9.52373 4.5 9.75689 4.5 10C4.5 10.2431 4.59658 10.4763 4.76849 10.6482C4.94039 10.8201 5.17355 10.9167 5.41667 10.9167H9.08333V14.5833C9.08333 14.8264 9.17991 15.0596 9.35182 15.2315C9.52373 15.4034 9.75689 15.5 10 15.5C10.2431 15.5 10.4763 15.4034 10.6482 15.2315C10.8201 15.0596 10.9167 14.8264 10.9167 14.5833V10.9167H14.5833C14.8264 10.9167 15.0596 10.8201 15.2315 10.6482C15.4034 10.4763 15.5 10.2431 15.5 10C15.5 9.75689 15.4034 9.52373 15.2315 9.35182C15.0596 9.17991 14.8264 9.08333 14.5833 9.08333H10.9167V5.41667Z" fill="#B46909"/>
                        </svg>
                        Add Answer
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="editElementData">
              <h5>Edit Selected Visual Element Configuraiton</h5>
              <p>Adjust the properties of the selected element</p>
              <table>
                <tbody>
                  <tr>
                    <td>Shape</td>
                    <td>
                      <select v-model="editElementData.shape">
                        <option value="rectangle">Rectangle</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>Styles</td>
                    <td style="display: grid; grid-template-columns: 1fr 1fr;">
                      <span>Fill:</span>
                      <input type="color" v-model="editElementData.styles.backgroundColor" />
                      <span>Width:</span>
                      <input type="number" v-model="editElementData.styles.width" />
                      <span>Height:</span>
                      <input type="number" v-model="editElementData.styles.height" />
                      <span>X:</span>
                      <input type="number" v-model="editElementData.styles.left" />
                      <span>Y:</span>
                      <input type="number" v-model="editElementData.styles.height" />
                      <span>Z-Index</span>
                      <input type="number" v-model="editElementData.styles.zIndex" />
                      <span>Font Size:</span>
                      <input type="number" v-model="editElementData.styles.fontSize" />
                    </td>
                  </tr>
                  <tr>
                    <td>Content</td>
                    <td>
                      <input type="text" v-model="editElementData.content"  />
                    </td>
                  </tr>
                  <tr>
                    <td>Events</td>
                    <td style="display: grid; grid-template-columns: 1fr 1fr;">
                      <span>on_hover:</span>
                      <div></div>
                      <span>on_click:</span>
                      <div></div>
                      <span>on_double_click:</span>
                      <div></div>
                    </td>
                  </tr>
                  <tr>
                    <td>Answer Value</td>
                    <td>
                      <input type="text" v-model="editElementData.answer_value" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section v-else-if="fullDataStructure.classification == 'Questionnaire'">
            <div style="display: flex; justify-content: space-between;">
              <b>Child View</b>
            </div>
            <div id="preview-screen-specialist" :style="{backgroundColor:fullDataStructure.Questions[questionIndex].background_color, position: 'relative', height: '500px'}" style="border: solid #8E8E8E 1px;">
              <DragResizeElement
                v-for="(element, index2) in fullDataStructure.Questions[questionIndex].Elements" :key="`element-${index2}`"
                :style="{
                  top: `${element.styles.top}px`,
                  left: ` ${element.styles.left}px`,
                  width: `${element.styles.width}px`,
                  height: `${element.styles.height}px`,
                  backgroundColor: element.styles.backgroundColor,
                  zIndex: element.styles.zIndex,
                  fontSize: `${element.styles.fontSize}px`,
                }"
                class="resizable-button-container"
                @deselectObjectMoveResize="deselectObjectMoveResize"
                @selectObjectMoveResize="selectObjectMoveResize"
                @emitNewChangeOccured="emitNewChangeOccured"
                :detailsObject="element"
                :bound="true"
              >
                <img v-if="element.image != ''" :src="`${reverseProxy}/api/${element.image}`" width="100%" height="100%">
                <div class="placeholder-rect" @click="editElementData = element">{{ element.content }}</div>
              </DragResizeElement>
            </div>
            <div>
              <h3>Edit Question Configuration</h3>
              <table>
                <tbody>
                  <tr>
                    <td>Options:</td>
                    <td style="width: 100%; padding-left: 1rem">
                      <input v-model="addNewQuestionnaireInput" style="height: 100%; padding: .5rem;" type="text" placeholder="Enter Option" />
                      <button style="margin-left: 1rem;" @click="addElementToQuestionForQuestionnaire(addNewQuestionnaireInput, fullDataStructure.Questions[questionIndex].Elements)" class="secondary-gray-button-sm-global">Add Option</button>

                      <div v-for="(item, index) in fullDataStructure.Questions[questionIndex].Elements" :key="index">
                        <input v-model="item.content" type="text" style="border: solid 1px black;"/>
                        <svg @click="deleteElementFromQuestionnaire(index, fullDataStructure.Questions[questionIndex].Elements)" xmlns="http://www.w3.org/2000/svg" class="svg-delete" width="1rem" viewBox="0 0 640 640"><path d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z"/></svg>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <section class="question-sidebar">
            <button>Prompts and Hints</button>
          </section>
        </div>
      </div>
      <div v-else-if="currStep == 'exampleReport'">
        <ConfigureReportNewApp :applicationID="applicationID" @backToAppConfig="backToAppConfig"/>
      </div>
    </div>
  </div>
</template>

  <script>
    import instance from '../axios.js';
    //import draggable from 'vuedraggable';
    import DragResizeElement from './subComponents/DragResizeElement.vue';
    import { v4 as uuidv4 } from 'uuid';
    import ConfigureReportNewApp from './subComponents/ConfigureReportNewApp.vue';

    export default {
      components: {
        //draggable,
        DragResizeElement,
        ConfigureReportNewApp
      },
      data() {
        return {
          reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
          fullDataStructure: null,
          categorizationsData: null,
          nestedCategorizations: null,
          applicationID: null,
          currStep: 'questions-list',
          questionIndex: -1,
          formatType: 'grid',
          showChildView: false,
          selectedObjectMoveResize: {
            element: null,
            detailsObject: null,
          },
          configDragResizeWindow: false,
          loadingPublishApps: false,
          loadingSaveAllChanges: false,
          loadingSaleChanges: false,
          loadingPricingChange: false,
          loadingUpdateAppMetaData: false,

          newQuestionModalIndex: 0,
          inputNewQuestion: {
            typeSelect: '',
            categorySelect: '',
            sub_categorySelect: '',
            typeNew: '',
            categoryNew: '',
            sub_categoryNew: '',
            question: '',
            ageRangeNewBegin: '',
            ageRangeNewEnd: '',
            typicalDurationNewBegin: '',
            typicalDurationNewEnd: '',
            timeOutNewBegin: '',
            timeOutNewEnd: '',
            mediaList: [],
            answerType: 'mcq',
            radioBinaryOrScaled: 'binary',
            correctAnswers: [],
          },

          addNewQuestionnaireInput: '',

          editQuestionTitle: false,
          showNestingTree: false,

          inputModalCategorizations: {
            typeAdd: '',
            categoriesAdd: '',
            subCategoryAdd: '',
            selectType: '',
            selectSubCategType: '',
            selectSubCategCategory: '',
          },

          settingsAppModalIndex: 0,
          inputAppModal: null,

          editElementData: null,
        }
      },
      async created() {
        this.applicationID = this.$route.params.applicationID;
        try {
          let fullDataStructureResponse = await instance.get(`/api/appAdmin/application/structure/${this.applicationID}`);
          this.fullDataStructure = fullDataStructureResponse.data;
          let categorizations = await instance.get(`/api/appAdmin/categorization/${this.applicationID}`);
          this.categorizationsData = {
            ...categorizations.data,
            areas: [this.fullDataStructure.area]
          };

          if (this.fullDataStructure.Questions.length > 0) {
            this.questionIndex = 0;
          }

          this.fullDataStructure.Questions.sort((a, b) => a.question_order - b.question_order);

          for (let i = 0; i < this.fullDataStructure.Questions.length; i++) {
            //parse the score points into usuable strings
            //add temperary variables for functionality
            this.fullDataStructure.Questions[i].specialist_buttons = JSON.parse(this.fullDataStructure.Questions[i].specialist_buttons);
/*             this.fullDataStructure.Questions[i].time_out = this.intervalToSeconds(this.fullDataStructure.Questions[i].time_out);
            this.fullDataStructure.Questions[i].typical_duration = this.intervalToSeconds(this.fullDataStructure.Questions[i].typical_duration); */
            this.fullDataStructure.Questions[i].typicalDurationTimer = null;
            this.fullDataStructure.Questions[i].timeOutTimer = null;
            this.fullDataStructure.Questions[i].questionDuration = null;
            this.fullDataStructure.Questions[i].typicalDurationTimerElapsedTime = this.intervalToSeconds(this.fullDataStructure.Questions[i].typical_duration);
            this.fullDataStructure.Questions[i].timeOutTimerElapsedTime = this.intervalToSeconds(this.fullDataStructure.Questions[i].time_out);
            this.fullDataStructure.Questions[i].questionDurationTimerElapse = 0;

            for (let j = 0; j < this.fullDataStructure.Questions[i].Elements.length; j++) {
              this.fullDataStructure.Questions[i].Elements[j].styles = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].styles)
              this.fullDataStructure.Questions[i].Elements[j].events_actions = JSON.parse(this.fullDataStructure.Questions[i].Elements[j].events_actions)
            }
          }

          this.createNestedCategorizations(this.fullDataStructure.Questions);
          this.resetSettingAppModal();
        } catch (err) {
          console.error(err);
        }
      },
      methods: {
        switchStep(step) {
          this.currStep = step;
        },
        createNestedCategorizations(questionArray) {
          const result = {};
          questionArray.forEach(({ type, category, sub_category }) => {
            if (type == '') {
              return;
            }
            if (!result[type]) {
              result[type] = {};
            }
            if (!result[type][category]) {
              result[type][category] = {};
            }
            result[type][category][sub_category] = true;
          });
          this.nestedCategorizations = result;
        },
        resetSettingAppModal() {
          const range = this.fullDataStructure.age_range;
          const [start, end] = range
            .replace(/[[\]()]/g, '')
            .split(',')
            .map(Number);

          const [hours, minutes] = this.fullDataStructure.estimated_duration.split(':');

          this.inputAppModal = {
            classification: this.fullDataStructure.classification,
            custom_id: this.fullDataStructure.custom_id,
            title: this.fullDataStructure.title,
            subtitle: this.fullDataStructure.subtitle,
            info: this.fullDataStructure.info,
            area: this.fullDataStructure.area,
            application_custom_id: this.fullDataStructure.application_custom_id,
            image: this.fullDataStructure.image,
            on_sale: this.fullDataStructure.on_sale,
            currency_code: this.fullDataStructure.currency_code,
            single_unit_pricing: this.fullDataStructure.single_unit_pricing,
            monthly_subscription_pricing: this.fullDataStructure.monthly_subscription_pricing,
            ageRangeBegin: start,
            ageRangeEnd: end,
            estimatedDurationHours: hours,
            estimatedDurationMinutes: minutes
          };
        },
        pushURL(url) {
          this.$router.push(url);
        },
        addElementToQuestionForQuestionnaire(content, arrayToAddTo) {
          const el = document.getElementById("preview-screen-specialist");
          const { width: parentW, height: parentH } = el.getBoundingClientRect();

          const padding = 10;       // space *between* elements
          const outerPadding = 15;  // padding around entire layout

          // 1. Add the new element
          arrayToAddTo.push({
            question_id: this.fullDataStructure.Questions[this.questionIndex].question_id,
            shape: "rectangle",
            styles: {
              backgroundColor: "#E8A011",
              width: 0,   // temporarily, will be recalculated
              height: 0,  // temporarily, will be recalculated
              left: 0,
              top: 0,
              zIndex: 2,
              fontSize: 16
            },
            content: content,
            events_actions: { value: "click_action" },
            image: '',
            answer_value: ''
          });

          // 2. Recalculate layout for all elements
          const count = arrayToAddTo.length;

          // Vertical space removed by padding between items
          const totalInnerPadding = padding * (count - 1);

          // Available height minus *outer* padding on both top & bottom
          const availableHeight = parentH - totalInnerPadding - (outerPadding * 2);

          // Height per item
          const itemHeight = availableHeight / count;

          // Width inside container (also padded left & right)
          const itemWidth = parentW - (outerPadding * 2);

          // Starting point (outer padding from top)
          let currentTop = outerPadding;

          arrayToAddTo.forEach(obj => {
            obj.styles.width = itemWidth;
            obj.styles.height = itemHeight;
            obj.styles.left = outerPadding;  // pushes layout inward from left border
            obj.styles.top = currentTop;

            currentTop += itemHeight + padding;
          });

          this.addNewQuestionnaireInput = '';
        },
        deleteElementFromQuestionnaire(index, arrayToDeleteFrom) {
          // 1. Remove element at index
          arrayToDeleteFrom.splice(index, 1);

          // 2. Recalculate layout if any elements remain
          if (arrayToDeleteFrom.length === 0) return;

          const el = document.getElementById("preview-screen-specialist");
          const { width: parentW, height: parentH } = el.getBoundingClientRect();

          const padding = 10;       // space *between* elements
          const outerPadding = 15;  // padding around entire layout

          const count = arrayToDeleteFrom.length;

          // Vertical space removed by padding between items
          const totalInnerPadding = padding * (count - 1);

          // Available height minus *outer* padding on both top & bottom
          const availableHeight = parentH - totalInnerPadding - (outerPadding * 2);

          // Height per item
          const itemHeight = availableHeight / count;

          // Width inside container (also padded left & right)
          const itemWidth = parentW - (outerPadding * 2);

          // Starting point (outer padding from top)
          let currentTop = outerPadding;

          arrayToDeleteFrom.forEach(obj => {
            obj.styles.width = itemWidth;
            obj.styles.height = itemHeight;
            obj.styles.left = outerPadding;
            obj.styles.top = currentTop;

            currentTop += itemHeight + padding;
          });
        },
        editElementToQuestionForQuestionnaire(elementToAdd, arrayToAddTo) {
          arrayToAddTo.push(elementToAdd);
        },
        addingNestedCategorizations(block) {
          if (block == 'type') {
            if (this.inputModalCategorizations.typeAdd == '') {
              alert('Input for Type cannot be empty');
              return;
            }
            this.categorizationsData.types.push(this.inputModalCategorizations.typeAdd);
            this.nestedCategorizations[this.inputModalCategorizations.typeAdd] = {};
            this.inputModalCategorizations.typeAdd = '';
          } else if (block == 'category') {
            if (this.inputModalCategorizations.categoriesAdd == '' || this.inputModalCategorizations.selectType == '') {
              alert('Input for Category cannot be empty');
              return;
            }
            this.categorizationsData.categories.push(this.inputModalCategorizations.categoriesAdd);
            this.nestedCategorizations[this.inputModalCategorizations.selectType][this.inputModalCategorizations.categoriesAdd] = {};
            this.inputModalCategorizations.categoriesAdd = '';
            this.inputModalCategorizations.selectType = '';
          } else if (block == 'subCateg') {
            if (this.inputModalCategorizations.subCategoryAdd == '' || this.inputModalCategorizations.selectSubCategType == '' || this.inputModalCategorizations.selectSubCategCategory == '') {
              alert('Input for SubCategory cannot be empty');
              return;
            }
            this.categorizationsData.sub_categories.push(this.inputModalCategorizations.subCategoryAdd);
            this.nestedCategorizations[this.inputModalCategorizations.selectSubCategType][this.inputModalCategorizations.selectSubCategCategory][this.inputModalCategorizations.subCategoryAdd] = true;
            this.inputModalCategorizations.subCategoryAdd = '';
            this.inputModalCategorizations.selectSubCategType = '';
            this.inputModalCategorizations.selectSubCategCategory = '';
          }
        },
        async updateApplicationMetaData() {
          function toInterval(hours, minutes) {
            const hh = String(hours).padStart(2, '0');
            const mm = String(minutes).padStart(2, '0');
            const ss = '00'; 
            return `${hh}:${mm}:${ss}`;
          }
          try {
            this.loadingUpdateAppMetaData = true;

            this.fullDataStructure.classification = this.inputAppModal.classification;
            this.fullDataStructure.custom_id = this.inputAppModal.custom_id;
            this.fullDataStructure.title = this.inputAppModal.title;
            this.fullDataStructure.subtitle = this.inputAppModal.subtitle;
            this.fullDataStructure.info = this.inputAppModal.info;
            this.fullDataStructure.image = this.inputAppModal.image;
            this.fullDataStructure.area = this.inputAppModal.area;
            this.fullDataStructure.application_custom_id = this.inputAppModal.application_custom_id;
            this.fullDataStructure.on_sale = this.inputAppModal.on_sale == "true" ? true : false;
            this.fullDataStructure.currency_code = this.inputAppModal.currency_code;
            this.fullDataStructure.single_unit_pricing = this.inputAppModal.single_unit_pricing;
            this.fullDataStructure.monthly_subscription_pricing = this.inputAppModal.monthly_subscription_pricing;
            this.fullDataStructure.age_range = `[${this.inputAppModal.ageRangeBegin},${this.inputAppModal.ageRangeEnd}]`;
            this.fullDataStructure.estimated_duration = toInterval(this.inputAppModal.estimatedDurationHours, this.inputAppModal.estimatedDurationMinutes);

            this.saveAllData();
            this.loadingUpdateAppMetaData = false;
          } catch (e) {
            alert('error occured')
            this.loadingUpdateAppMetaData = false;
            console.error(e);
          }
        },
        backToAppConfig() {
          this.switchStep('questions-list');
        },
        formatTimestamp(timestamp) {
          if (timestamp == null) {
            return 'null';
          }

          const date = new Date(timestamp);
          const options = { year: 'numeric', month: 'long', day: 'numeric' };
          return date.toLocaleDateString('en-US', options);
        },
        intervalToSeconds(interval) {
          const [h, m, s] = interval.split(":").map(Number);
          return h * 3600 + m * 60 + s;
        },
        changeIndex(step, index) {
         if (step == 'question') {
            if (index < 0) {
              this.questionIndex = 0;
            }
            else if (index >= this.fullDataStructure.Questions.length) {
              this.questionIndex = this.fullDataStructure.Questions.length-1;
            }
            else {
              this.questionIndex = index;
            }
          }
        },
        changePreviewQuestion(newIndex, previousIndex) {
          this.changeIndex('question', newIndex);
          if (0 <= newIndex && newIndex < this.fullDataStructure.Questions.length) {
            this.previewTimingPack(this.fullDataStructure.Questions[previousIndex], false);
            this.previewTimingPack(this.fullDataStructure.Questions[newIndex], true);
          }
        },
        childViewToggle() {
          this.showChildView = !this.showChildView;
        },
        async addMediaEditQuestion(event) {
          try {
            const formData = new FormData();
            formData.append("image", event.target.files[0]);
            let response = await instance.post(`/api/appAdmin/application/image/${this.fullDataStructure.application_id}`, formData);
            event.target.value = null;
              
            this.fullDataStructure.Questions[this.questionIndex].Elements.push({
              question_id: this.fullDataStructure.Questions[this.questionIndex].question_id,
              shape: "rectangle",
              styles: {"backgroundColor":"#E8A011","width":200,"height":100,"left":50,"top":50,"zIndex":2,"fontSize":16},
              content: "",
              events_actions: {"value":"click_action"},
              image: response.data,
              answer_value: ''
            });
          } catch (e) {
            console.error(e);
          }
        },
        addNewQuestion() {
          function toInterval(hours, minutes) {
            const h = parseInt(hours, 10) || 0;
            const m = parseInt(minutes, 10) || 0;

            const totalMinutes = h * 60 + m;
            const adjustedHours = Math.floor(totalMinutes / 60);
            const adjustedMinutes = totalMinutes % 60;

            const hh = String(adjustedHours).padStart(2, '0');
            const mm = String(adjustedMinutes).padStart(2, '0');
            const ss = '00';
            return `${hh}:${mm}:${ss}`;
          }

          let typeInputRef = this.inputNewQuestion.typeSelect;
          let categInputRef = this.inputNewQuestion.categorySelect;
          let subCategInputRef = this.inputNewQuestion.sub_categorySelect;

          if (typeInputRef == 'none' || typeInputRef == null || categInputRef == 'none' || categInputRef == null) {
            alert(`Please select/add a type and category that is not "none"`);
            return;
          }

          if (subCategInputRef == null) {
            alert(`Please select "none" or another SubCategory`);
            return;
          }

          let id = uuidv4();
          let elements = [];
          
          for (let i = 0; i < this.inputNewQuestion.mediaList.length ; i++) {
            elements.push({
              ...this.inputNewQuestion.mediaList[i],
              question_id: id
            });
          }
          
          this.fullDataStructure.Questions.splice(this.fullDataStructure.Questions.length, 0, {
            application_id: this.applicationID,
            question_id: id,
            custom_id: '',
            question: this.inputNewQuestion.question,
            question_description: '',
            question_order: this.fullDataStructure.Questions.length,
            area: this.fullDataStructure.area,
            area_description: '',
            type: typeInputRef,
            type_description: '',
            category: categInputRef,
            category_description: '',
            sub_category: subCategInputRef,
            sub_category_description: '',
            background_color: '#FFFFFF',
            procedure: '',
            age_group: `[${this.inputNewQuestion.ageRangeNewBegin},${this.inputNewQuestion.ageRangeNewEnd}]`,
            specialist_prompt: '',
            specialist_buttons: [],
            child_view_original_screen_resolution: '804x640',
            highest_score_possible: 1,
            tts_child_prompts: [],
            time_out: toInterval(this.inputNewQuestion.typicalDurationNewBegin, this.inputNewQuestion.typicalDurationNewEnd),
            typical_duration: toInterval(this.inputNewQuestion.timeOutNewBegin, this.inputNewQuestion.timeOutNewEnd),
            note: '',
            grading_type: this.inputNewQuestion.answerType,
            correct_answers: [],
            followup_parent_id: null,
            activator_answer: "",

            Elements: elements,

            typicalDurationTimer: null,
            timeOutTimer: null,
            questionDuration: null,
            typicalDurationTimerElapsedTime: 0,
            timeOutTimerElapsedTime: 0,
            questionDurationTimerElapse: 0,
          });


          if (this.fullDataStructure.Questions.length > 0 && this.questionIndex <= -1) {
            this.questionIndex = 0;
          }

          //reset object/modal
          this.inputNewQuestion = {
            typeSelect: '',
            categorySelect: '',
            sub_categorySelect: '',
            question: '',
            ageRangeNewBegin: '',
            ageRangeNewEnd: '',
            typicalDurationNewBegin: '',
            typicalDurationNewEnd: '',
            timeOutNewBegin: '',
            timeOutNewEnd: '',
            mediaList: []
          }
          this.newQuestionModalIndex = 0;
        },
        getURLImage(file) {
          if (file != null && file != '') {
            return URL.createObjectURL(file);
          } else {
            return null;
          }
        },
        startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName) {
          //questionFunctions is Object
          questionFunctions[stopWatchName] = setInterval(() => {
            questionFunctions[stopWatchElapseTimeName]++;
          }, 1000);
        },
        stopStopWatch(questionFunctions, stopWatchName) {
          //questionFunctions is Object
          clearInterval(questionFunctions[stopWatchName]);
          questionFunctions[stopWatchName] = null;
        },
        resetStopWatch(questionObject, stopWatchName, stopWatchElapseTimeName) {
          let questionFunctions = questionObject;
          questionFunctions[stopWatchElapseTimeName] = 0;
          this.stopStopWatch(questionFunctions, stopWatchName);
          this.startStopWatch(questionFunctions, stopWatchName, stopWatchElapseTimeName);
        },
        startTimer(questionFunctions, timerName, timerElapseTimeName) {
          //questionFunctions is Object
          questionFunctions[timerName] = setInterval(() => {
            let temp = questionFunctions[timerElapseTimeName];
            if (temp - 1 < 0) {
              this.stopTimer(questionFunctions, timerName);
            }
            else {
              questionFunctions[timerElapseTimeName]--;
            }
          }, 1000);
        },
        stopTimer(questionFunctions, timerName) {
          //questionFunctions is Object
          clearInterval(questionFunctions[timerName]);
          questionFunctions[timerName] = null;
        },
        resetTimer(questionObject, timerName, timerElapseTimeName, originalTimeName) {
          let questionFunctions = questionObject;
          questionFunctions[timerElapseTimeName] = questionObject[originalTimeName];
          this.stopTimer(questionFunctions, timerName);
          this.startTimer(questionFunctions, timerName, timerElapseTimeName);
        },
        previewTimingPack(questionObject, setting) {
          let questionFunctions = questionObject;
          //turn on timings
          if (setting) {
            this.startTimer(questionFunctions, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime');
            this.startTimer(questionFunctions, 'timeOutTimer', 'timeOutTimerElapsedTime');
            this.startStopWatch(questionFunctions, 'questionDuration', 'questionDurationTimerElapse');
          }
          else {
            this.stopTimer(questionFunctions, 'typicalDurationTimer');
            this.stopTimer(questionFunctions, 'timeOutTimer');
            this.stopStopWatch(questionFunctions, 'questionDuration');
          }
        },
        previewTimingResetPack(questionObject) {
          this.resetTimer(questionObject, 'typicalDurationTimer', 'typicalDurationTimerElapsedTime', 'typicalDuration');
          this.resetTimer(questionObject, 'timeOutTimer', 'timeOutTimerElapsedTime', 'time_out');
          this.resetStopWatch(questionObject, 'questionDuration', 'questionDurationTimerElapse');
        },
        formatTimeStamp(timeStamp) {
          const dateStr = timeStamp;
          const date = new Date(dateStr);
          const formattedDate = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;

          return formattedDate;
        },
        openModal(id) {
          document.getElementById(id).showModal();
        },
        closeModal(id) {
          document.getElementById(id).close();
        },
        formatForNewResolution(elementID) {
          this.$nextTick(() => {
            let currentQuestionInstance = this.fullDataStructure.Questions[this.questionIndex];
            let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
            let newWidth = document.getElementById(elementID).offsetWidth;
            let newHeight = document.getElementById(elementID).offsetHeight;
            if (newWidth == originalWidth && newHeight == originalHeight) {
              return;
            }

            //[x,y] transform coordinates from original to new resolution
            let xTransform = newWidth / originalWidth;
            let yTransform = newHeight / originalHeight;

            for (let i = 0; i < currentQuestionInstance.Elements.length; i++) {
              currentQuestionInstance.Elements[i].styles.left *= xTransform;
              currentQuestionInstance.Elements[i].styles.top *= yTransform;
              currentQuestionInstance.Elements[i].styles.height *= yTransform;
              currentQuestionInstance.Elements[i].styles.width *= xTransform;
            }

            currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
          });
        },
        async saveAllData() {
          try {
            this.loadingSaveAllChanges = true;

            let { Questions, ...application } = this.fullDataStructure;
            let questions = [];
            let elements = [];

            for (const q of Questions) {
              const { Elements, ...questionWithoutElements } = q;
              questions.push(questionWithoutElements);

              for (const el of Elements) {
                elements.push(el);
              }
            }

            questions = questions.map((question, questionIndex) => ({
              application_id: question.application_id,
              question_id: question.question_id,
              custom_id: question.custom_id,
              question: question.question,
              question_description: question.question_description,
              question_order: questionIndex,
              area: question.area,
              area_description: question.area_description,
              type: question.type,
              type_description: question.type_description,
              category: question.category,
              category_description: question.category_description,
              sub_category: question.sub_category,
              sub_category_description: question.sub_category_description,
              background_color: question.background_color,
              procedure: question.procedure,
              age_group: question.age_group,
              specialist_prompt: question.specialist_prompt,
              specialist_buttons: JSON.stringify(question.specialist_buttons),
              child_view_original_screen_resolution: question.child_view_original_screen_resolution,
              highest_score_possible: parseInt(question.highest_score_possible),
              TTS_child_prompts: question.tts_child_prompts,
              time_out: question.time_out,
              typical_duration: question.typical_duration,
              note: question.note,
              grading_type: question.grading_type,
              correct_answers: question.correct_answers,
              followup_parent_id: question.followup_parent_id,
              activator_answer: question.activator_answer
            }));

            elements = elements.map(element => ({
              ...element,
              styles: JSON.stringify(element.styles),
              events_actions: JSON.stringify(element.events_actions)
            }));

            await instance.post(`/api/appAdmin/application/${this.fullDataStructure.application_id}`, {
              application,
              questions,
              elements
            });

            this.loadingSaveAllChanges = false;
            alert('Data Saved');
          } catch (e) {
            alert(`Error Data not Saved: ${e.message}`);
            this.loadingSaveAllChanges = false;
            console.error(e);
          }
        },
        async publishApp(boolean) {
          try {
            this.loadingPublishApps = true;
            const formData = new FormData();
            formData.append("published", boolean);
            await instance.patch(`/api/appAdmin/${this.applicationID}`, formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            this.fullDataStructure.published = boolean;
            this.loadingPublishApps = false;
            alert(`Application Has Been ${boolean ? 'Published' : 'UnPublished'}`);
          } catch (e) {
            console.error(e);
            this.loadingPublishApps = false;
            alert('Error Application Was Not Published');
          }
        },
        selectObjectMoveResize(event, detailsObject) {
          let elements = document.querySelectorAll('.selected-drag-resize');
          elements.forEach(element => {
            let handles = element.querySelector('.resizeHandles');
            handles.classList.remove('activeHandles'); 
            element.classList.remove('selected-drag-resize');
          });

          this.selectedObjectMoveResize.detailsObject = detailsObject;
          this.selectedObjectMoveResize.element = event.currentTarget;
        },
        deselectObjectMoveResize() {
          let elements = document.querySelectorAll('.selected-drag-resize');
          elements.forEach(element => {
            let handles = element.querySelector('.resizeHandles');
            handles.classList.remove('activeHandles'); 
            element.classList.remove('selected-drag-resize');
          });
          Object.keys(this.selectedObjectMoveResize).forEach(key => {
            this.selectedObjectMoveResize[key] = null;
          });
        },
        emitNewChangeOccured() {
          this.selectedObjectMoveResize.detailsObject.styles.top = parseInt(this.selectedObjectMoveResize.element.style.top, 10);
          this.selectedObjectMoveResize.detailsObject.styles.left = parseInt(this.selectedObjectMoveResize.element.style.left, 10);
          this.selectedObjectMoveResize.detailsObject.styles.width = parseInt(this.selectedObjectMoveResize.element.style.width, 10);
          this.selectedObjectMoveResize.detailsObject.styles.height = parseInt(this.selectedObjectMoveResize.element.style.height, 10);
        },
        async newQuestionMediaChanges(event) {
          try {
            const formData = new FormData();
            formData.append("image", event.target.files[0]);
            let response = await instance.post(`/api/appAdmin/application/image/${this.fullDataStructure.application_id}`, formData);

            this.inputNewQuestion.mediaList.push({
              shape: "rectangle",
              styles: {"backgroundColor":"#E8A011","width":200,"height":100,"left":50,"top":50,"zIndex":2,"fontSize":16},
              content: "",
              events_actions: {},
              image: response.data,
              answer_value: ''
            });
            event.target.value = null;
          } catch (e) {
            console.error(e);
          }
        },
        toggleAccordion(event) {
          let ref = event.target.nextElementSibling;
          if (ref.style.display === "block") {
            ref.style.display = "none";
            event.target.classList.remove("accordion-active");
          } else {
            ref.style.display = "block";
            event.target.classList.add("accordion-active");
          }
        },
        async uploadAppImageToServer(event, object, variable) {
          try {
            if (event.target.files.length > 0) {
              object[variable] = event.target.files[0];
              const formData = new FormData();
              formData.append("image", event.target.files[0]);
              let response = await instance.post(`/api/appAdmin/application/image/${this.fullDataStructure.application_id}`, formData);
              event.target.value = '';
              object[variable] = response.data;
            }
          } catch (e) {
            console.error(e)
          }
        },
        addNewCorrectAnswer(array) {
          array.push("");
        },
        removeNewCorrectAnswer(indexToRemove) {
          if (indexToRemove > -1 && indexToRemove < this.inputNewQuestion.correctAnswers.length) {
            this.inputNewQuestion.correctAnswers.splice(indexToRemove, 1);
          }
        },
        addCurrentCorrectAnswer(array) {
          array.push("");
        },
        removeCurrentCorrectAnswer(indexToRemove) {
          if (indexToRemove > -1 && indexToRemove < this.fullDataStructure.Questions[this.questionIndex].correct_answers.length) {
            this.fullDataStructure.Questions[this.questionIndex].correct_answers.splice(indexToRemove, 1);
          }
        },
      },
    }
  </script>
  
  <style lang="scss" scoped>
    @use 'sharedSCSS/globalSharedVariables';

    $sidebar-width: 400px;
    $primary-color: globalSharedVariables.$brand-400;
    $greenFull: #ace2c6;
    $greenLight: #D9F2E6;
    $redZero: #FFBCBC;

    section {
      padding: 20px;
    }

    h4 {
      font-weight: 700;
      user-select: none;
    }

    p {
      font-weight: 400;
      font-size: 1rem;
    }

    textarea {
      height: 100px;
      width: 100%;
    }

    .orangeText-600 {
      color: globalSharedVariables.$brand-600;
    }

    #container {
      position: relative;

      > div {
        width: 100%;
      }

      img {
        -webkit-user-drag: none
      }

      .brown-svg-text-button {
        color: globalSharedVariables.$brand-800;
        cursor: pointer;

        label {
          cursor: pointer;
          font-weight: 400;
        }

        svg {
          cursor: pointer;
          path {
            stroke: globalSharedVariables.$brand-800;
          }
        }
      }
    }

    #navigation-bar-container {
      #navigation-bar-application {
        height: globalSharedVariables.$navbar-height;
        border-bottom: 1px #CBCBCB solid;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;

        > div {
          display: flex;
          align-items: center;
          cursor: pointer;
        }

        h3 {
          margin: 0 1rem;
        }

        svg {
          margin-left: 2rem;
        }
      }

      #navigation-bar-question {
        height: globalSharedVariables.$navbar-height;
        border-bottom: 1px #CBCBCB solid;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 1rem;

        > div {
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
    }

    #main-box-container {
      .main-box-grid {
        display: grid;
        grid-template-columns: 1fr 330px;
        height: calc(100dvh - #{globalSharedVariables.$navbar-height});

        .question-grid {
          display: grid;
          grid-template-columns: 50px 1fr;
          row-gap: 1rem;
          margin: 10px 0;

          > *:nth-child(1) {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
          }
        }

        .application-sidebar, .question-sidebar {
          font-weight: 700;
          background-color: globalSharedVariables.$grey-50;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: globalSharedVariables.$grey-800;
          border-left: globalSharedVariables.$grey-200 1px solid;

          a {
            color: globalSharedVariables.$grey-800;
          }
        }

        .svg-delete {
          &:hover {
            fill: red;
            cursor: pointer;
          }

          path:hover {
            stroke: red;
            stroke-width: 2;
          }
        }
      }
    }

    .sideBar-box {
      width: $sidebar-width;
      position: fixed;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: calc(100vh - #{globalSharedVariables.$navbar-height});
    
      h4 {
        text-align: center;

        input[type="text"] {
          font-size: 1.5rem;
          width: 75%;
        }
      }

      .navigation-buttons {
        button {
          width: 100%;
          margin: 5px 0;
        }
      }

      #add-question-container {
        font-size: .7rem;
        border: solid black 1px;
        padding: .5rem;
        border-radius: 1rem;

        .add-categorization-container {
          display: flex;
          align-items: center;

          input[type="text"] {
            font-size: .9rem;
          }

          > button {
            padding: 0;
            width: 17px;
            height: 17px;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .categorization-radio-container {
          margin-left: 1rem;
          margin-top: 5px;
          display: flex;
          align-items: center;

          > button {
            padding: 0;
            width: 17px;
            height: 17px;
            margin-left: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .modify-buttons {
          border-radius: 5px;
          margin: 0 .25rem;
          width: 50px;
          text-align: center;
          padding: 0;
          font-size: 1rem;
        }
      }

      .sideBar-list {
        flex-grow: 1;
        margin: 1rem 0;

        input {
          padding: 5px 10px;
        }

        .drag-sidelist {
          cursor: grab;
          margin: 5px 0;
          border: solid black 1px;
          padding: .5rem;
          border-radius: 5px;

          .drag-side-list-text-container {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }

    .main-box {
      margin-left: $sidebar-width;

      .editorMode-button {
        color: grey;
        border: solid grey 1px;
        font-size: .6em;
        width: 150px;
        border-radius: 50rem;
        padding-left: .5rem;
        padding-right: .5rem;
        margin-top: .25rem;
        margin-left: .5rem;
      }

      .pencil-icon {
        color: grey;
      }

      .styleList-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        cursor: pointer;
        width: 100%;
        margin: 5px 0;
      }

      .descripText {
        font-weight: 400;
        color: #606060;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    #config-control-box-specialist {
      display: grid;
      grid-template-columns: 1fr 4fr 1fr;
      row-gap: 2rem;
      column-gap: 1rem;

      .border-color-primary {
        outline: solid 2px $primary-color;
      }

      .prev-ques-nav-buttons {
        cursor: pointer;
        padding: 0;
        margin: 0 2px;

        img {
          width: 30px;
          border-radius: 50rem;

          &:hover {
            background-color: $primary-color;
          }
        }
      }
      
      .typicalDuration {
        border: solid #FAFD5F 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .time_out {
        border: solid #2B870B 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .totalDuration {
        border: solid black 2px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .exampleButton {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: 100%;

        &:hover {
          opacity: .8;
        }
      }

      .preview-icons {
        width: 50px;
        height: 24px;
      }

      .preview-icon-container {
        font-size: xx-small;
        text-align: center;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 50px;
        width: 50px;
        cursor: pointer;

        div {
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 50%);
        }

        &.disabled-preview-icon {
          opacity: .2;
          cursor: default;
        }
      }

      .circle-button {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .greenFull-button {
        box-shadow: inset 0 0 2px 2px $greenFull;
        color: $greenFull;
        border: 1px solid green;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenFull;
        }

        &.selected-score-button {
          background-color: $greenFull;
        }
      }

      .greenLight-button {
        box-shadow: inset 0 0 2px 2px $greenLight;
        color: $greenLight;
        border: 1px solid rgb(0, 156, 0);
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $greenLight;
        }

        &.selected-score-button {
          background-color: $greenLight;
        }
      }

      .red-button {
        box-shadow: inset 0 0 2px 2px $redZero;
        color: $redZero;
        border: 1px solid red;
        -webkit-text-stroke: 1px black;

        &:hover {
          background-color: $redZero;
        }

        &.selected-score-button {
          background-color: $redZero;
        }
      }

      .icons-grid {
        display: grid;
        grid-template-columns: repeat(11, auto);
      }
    }

    #question-configuration-window-container {
      height: 75%;
      width: 75%;

      .template-container {
        position: relative;
        display: inline-block;

        svg {
          width: 100px;
          height: 100px;
          border: solid black 1px;
          border-radius: 5px;
          margin: 2px;
        }
        button {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        
        &:hover button {
          display: block;
        }

        &:hover svg {
          fill-opacity: .1;
        }
      }
      svg {
        width: 100px;
        height: 100px;
        border: solid black 1px;
        border-radius: 5px;
        margin: 2px;
      }
    }

    .config-drag-resize-window {
      font-weight: 400;
      border: solid black 2px;
      border-radius: 5px;
      padding: .5rem;
      z-index: 150;
      background-color: white;
    }

    .drag-resize-element-container {
      overflow: auto;
      height: 100%;
      background-color: white;

      h4 {
        text-align: center;
      }

      button {
        font-size: .8rem;
      }

      .masonry {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        grid-auto-rows: auto;
        gap: 20px;

        > div {
          &.grid-span-column-2 {
            grid-column: span 2;
          }

          hr {
            margin: 5px 0;
            border-width: 0;
            background-color: black;
            height: 1px;
            opacity: 1;
          }

          h5 {
            text-align: center;
            text-decoration: underline;
          }

          h6 {
            text-align: center;
          }

          border: solid black 1px;
          border-radius: 10px;
          padding: 1rem;
        }
      }
    }

    #modal-config-question {
      width: 75%;

      input[type="text"] {
        padding: 5px 5px;
      }

      input, textarea, select {
        font-size: .8rem;
      }
    }

    #modal-settings {
      h3, h5 {
        text-align: center;
        margin-bottom: 2rem;
      }

      label {
        display: block;
        font-weight: 700;
      }

      .two-column {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 2rem;
      }

      nav {
        > span {
          margin: 0 1rem;
          padding: 10px;
          cursor: pointer;
          font-weight: 700;
        }

        .selected-nav {
          background-color: globalSharedVariables.$brand-100;
          color: globalSharedVariables.$brand-800;
          border-radius: 5px;
        }
      }
    }

    #modal-Categorizations {
      label {
        display: block;
        font-weight: 700;
        margin: 0;
        margin-top: 2rem;
      }

      small {
        color: #5A5A5A;
        display: block;
      }

      .internalGrid {
        display: grid;
        grid-template-columns: 1fr 50px;
        column-gap: 1rem;
      }

      .internalGrid2 {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 1rem;
        height: 34px;
      }

      .back-button {
        color: #9D5F0E;
        cursor: pointer;
      }
    }

    #modal-newQuestion {
      .two-column-box {
        display: grid;
        grid-template-columns: 240px 500px;
        column-gap: 1rem;

        p {
          color: #5A5A5A;
        }

        .side-nav-bar {
          font-weight: 700;

          > div {
            padding: .5rem;
            color: globalSharedVariables.$grey-400;

            .circle {
              width: 2rem;
              height: 2rem;
              border-radius: 50%;
              border: solid #E0E0E0 1px;
              color: #727474;
              display: inline-flex;
              justify-content: center;
              align-items: center;
              font-weight: 400;
              margin-right: 10px;
              background-color: white;
            }

            &.active-index {
              background-color: globalSharedVariables.$brand-50;
              color: globalSharedVariables.$brand-700;

              .circle {
                color: globalSharedVariables.$brand-700;
                border: solid globalSharedVariables.$brand-700 1px;
                font-weight: 700;
              }
            }
          }
        }

        > div:nth-child(2) {
          height: 100%;

          #answer-grading-container {
            #answer-type-container {
              display: flex;
              margin-bottom: 1rem;

              .answer-type-box {
                display: grid;
                grid-template-rows: 1fr 1fr;
                align-items: center;
                width: 140px;
                height: 120px;
                border-radius: 5px;
                border: solid #EBEBEB 1px;
                margin-right: 10px;
                color: #595959;
                cursor: pointer;
                font-weight: 700;

                &.selected-type {
                  background-color: globalSharedVariables.$brand-50;
                  border-color: globalSharedVariables.$brand-200;
                  color: globalSharedVariables.$brand-800;
                  
                  svg {
                    rect {
                      fill: globalSharedVariables.$brand-800;
                    }
                    path {
                      stroke: globalSharedVariables.$brand-800;
                    }
                  }
                }

                > div {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                  font-size: 14px;

                  &:first-child {
                    margin-top: 1rem;
                  }
                }
              }
            }

            .radio-system-container {
              display: grid;
              grid-template-columns: 20px 1fr;

              .subText {
                color: #595959;
              }
            }
          }

          .newQuestion-media-container {
            border: solid #D6D6D6 1px;
            padding: 1rem;
            border-radius: 5px;

            table {
              font-size: .8rem;
              width: 100%;
              
              input, select, option {
                font-size: .8rem;
                height: fit-content;
              }
            }
          }

          > div {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
          }

          small {
            color: #7E7E7E;
          }

          label {
            display: block;
            margin-top: 2rem;
            margin-bottom: 0;
          }

          input[type="text"], textarea {
            width: 100%;
          }

          input[type="text"], textarea, select {
            padding: .5rem;
          }

          input[type="text"], select {
            height: 42px;
          }

          .custom-file-label-global {
            width: fit-content;
          }

          .two-column {
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 2rem;
          }

          .nav-buttons {
            font-weight: 700;
          }
        }
      }
    }

    .resizable-image-container, .final-image-container {
      $local-border-radius: 1rem;

      background-color: $primary-color;
      border-radius: $local-border-radius;
      border: solid black 1px;
      position: absolute;
      user-select: none;
      cursor: pointer;

      img {
        border-radius: $local-border-radius;
      }
    }

    .resizable-button-container, .final-button-container {
      $local-border-radius: 1rem;

      background-color: $primary-color;
      position: absolute;
      border-radius: $local-border-radius;
      box-shadow: 0 0 5px 5px lightgrey;
      border: solid black 1px;
      user-select: none;
      cursor: pointer;
      
      .placeholder-rect {
        position: absolute;
        top: 0;
        left: 0;
        word-wrap: break-word;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        border-radius: $local-border-radius;
        object-fit: cover;
      }
    }
  </style>